<template>
	<div class="full page_container">
		<vxe-grid ref="deliverytable" :loading="loading" v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {

		},
		data() {
			return {
				loading:false,
				activeName: '',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			list_beforeCreateGrid(gridOptions){
				gridOptions.toolbarConfig =  {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '导出',
						status: 'success',
						code: 'export'
					},{
						name: '同步',
						status: 'primary',
						code: 'synchronous'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'emunid',
						title: '系统枚举ID',
					},{
						field: 'distrParamName',
						title: '快递公司',
					},
					{
						field: 'distrName',
						title: '快递名称'
					},
					{
						field: 'comUid',
						title: '公司ID'
					},
					{
						field: 'unitUid',
						title: '快递ID'
					}
				]
				gridOptions.formConfig = false
			},
			list() {
				return new Promise((resolve) => {
					this.$api.parcel.list().then((res)=>{
						resolve({
							list: res
						})
					})
				})
			},
			synchronous(){			
				this.loading = true
				this.$api.parcel.synchronous().then(()=>{
					this.loading = false
					this.$message.success('操作成功')
					this.$refs.deliverytable.commitProxy('query')
				},()=>{
					this.loading = false
				})
			}
		},
		components: {

		}
	}
</script>
